import { List } from "immutable"
import * as React from "react"
import { Pager } from "../../../components/pager"
import { Jumbo } from "../../components/jumbo"
import { Teasers } from "../../components/teaser"
import { initialNewsResponse, NewsOverviewLayoutProps, resultsClass } from "./newsOverviewState"

export const NewsOverviewLayout = (props: NewsOverviewLayoutProps) => {
  const { headerTitle, description, phImageUrl, phImageUrlLarge, imageAlt, newsLoader, currentPage, pageSize, setPage, key } = props
  const { news, totalResults } = newsLoader.kind == 'loaded' || newsLoader.kind == 'loading' ? newsLoader.value : initialNewsResponse

  const pager = totalResults
    ? Pager({ currentPage, pageSize, totalResults, setPage })
    : <></>

  return (
    <React.Fragment key={key}>
      <Jumbo
        title={headerTitle}
        contents={description}
        imageUrl={phImageUrl}
        imageUrlLarge={phImageUrlLarge}
        imageAlt={imageAlt}
        size="small"
      />
      <div className="container--lg align--center">
        <section className={resultsClass}>
          {news.length > 0
            ? <Teasers items={List(news)} />
            : <NoNews />
          }
        </section>
      </div>

      {pager}
    </React.Fragment>
  )
}

const NoNews = () => <div className="text--styled">
  <p className="weight--bold container--s">
    Op dit moment zijn er helaas geen nieuwsberichten beschikbaar.
  </p>
</div>